<div class="team-view">
    <!-- Invite Section -->
    <div class="invite-card">
        <div class="card-header">
            <div class="header-icon">
                <mat-icon>person_add</mat-icon>
            </div>
            <div class="header-content">
                <h3>Invite Team Member</h3>
                <p>Add new admins to your workspace</p>
            </div>
        </div>

        <div class="card-body">
            <form [formGroup]="inviteEmailForm" (ngSubmit)="inviteAdmins()" #formDirective="ngForm">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Email Address</mat-label>
                    <input matInput placeholder="colleague@company.com" formControlName="adminIds" required>
                    <mat-icon matSuffix>email</mat-icon>
                    <mat-error *ngIf="inviteEmailForm.get('adminIds').hasError('required')">Email is
                        required</mat-error>
                    <mat-error *ngIf="inviteEmailForm.get('adminIds').hasError('pattern')">Invalid email
                        format</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Select Role</mat-label>
                    <mat-select formControlName="role">
                        <mat-option *ngFor="let role of roles" [value]="role">{{role}}</mat-option>
                    </mat-select>
                    <mat-icon matSuffix>badge</mat-icon>
                </mat-form-field>

                <button mat-flat-button color="primary" class="invite-btn"
                    [disabled]="inviteEmailForm.invalid || isLoading">
                    <mat-icon>send</mat-icon>
                    <span>Send Invitation</span>
                </button>
            </form>
        </div>
    </div>

    <!-- Members List Section -->
    <div class="members-card">
        <div class="card-header">
            <div class="header-icon">
                <mat-icon>group</mat-icon>
            </div>
            <div class="header-content">
                <h3>Team Members <span class="badge" *ngIf="admins?.length">{{admins.length}}</span></h3>
                <p>Manage access and roles</p>
            </div>
        </div>

        <div class="members-list">
            <div class="member-item" *ngFor="let admin of admins; let i = index">
                <div class="member-avatar">
                    <span>{{admin.email.charAt(0).toUpperCase()}}</span>
                </div>
                <div class="member-info">
                    <div class="member-email">{{admin.email}}</div>
                    <div class="member-role" [class.super-admin]="admin.role === 'ENTERPRISE_ADMIN'">
                        {{admin.role === 'ENTERPRISE_ADMIN' ? 'Super Admin' : 'Admin'}}
                    </div>
                </div>
                <div class="member-status">
                    <span class="status-pill active">Active</span>
                </div>
                <div class="member-actions">
                    <!-- Only allow deleting if not deleting self and user is admin -->
                    <!-- Adjust logic based on exact requirements, here allowing delete if not self -->
                    <button mat-icon-button color="warn" class="delete-btn" *ngIf="currentUser?.email !== admin.email"
                        (click)="deleteAdmin(admin, i)" matTooltip="Remove Member">
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                </div>
            </div>

            <div class="empty-state" *ngIf="admins?.length === 0">
                <mat-icon>group_off</mat-icon>
                <p>No team members found</p>
            </div>
        </div>
    </div>
</div>